module.exports = __webpack_public_path__ + "static/kdb-banner-3-e147bc640fe50ab54248255a77240399.png";